import React from 'react';
import { COLORS } from '../../utils/theme';

type AlertVariant = 'success' | 'warning' | 'danger' | 'info';

const VARIANT_MAP: Record<AlertVariant, { text: string; bg: string; border: string }> = {
  success: COLORS.success,
  warning: COLORS.warning,
  danger: COLORS.danger,
  info: COLORS.info,
};

interface AlertBoxProps {
  /** Visual style variant */
  variant: AlertVariant;
  /** Optional emoji / icon shown on the left */
  icon?: string;
  /** Bold title line (optional) */
  title?: string;
  /** Body content */
  children: React.ReactNode;
  /** Extra inline style overrides */
  style?: React.CSSProperties;
}

export const AlertBox: React.FC<AlertBoxProps> = ({ variant, icon, title, children, style }) => {
  const scheme = VARIANT_MAP[variant];

  return (
    <div
      style={{
        background: scheme.bg,
        border: `1.5px solid ${scheme.border}`,
        borderRadius: 12,
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 14,
        ...style,
      }}
    >
      {icon && <span style={{ fontSize: 24, flexShrink: 0, lineHeight: 1.2 }}>{icon}</span>}
      <div style={{ flex: 1 }}>
        {title && (
          <strong style={{ color: scheme.text, display: 'block', marginBottom: 4, fontSize: 15, fontWeight: 700 }}>{title}</strong>
        )}
        <div style={{ color: scheme.text, fontSize: 14, lineHeight: 1.6 }}>{children}</div>
      </div>
    </div>
  );
};
